/* eslint-disable @nx/enforce-module-boundaries */
import { Search, SearchLineIcon } from '@mybridge/icons';
import {
  Box,
  CloseButton,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
} from '@mybridge/ui';
import React, { useState, useEffect, useContext } from 'react';
import { MyNetworkContext } from 'v4/components/network/context';
import { useDisclosure, useToast } from '@mybridge/ui/hooks';
import { Search2Icon } from '@chakra-ui/icons';
const MyNetworkSearchInput = ({ searchType, ...props }) => {
  const { searchQuery, setSearchQuery, setSearchQueryType } =
    useContext(MyNetworkContext);
  const searchBoxDisc = useDisclosure();
  const side = typeof window !== 'undefined' ? document.documentElement.dir : 'ltr';
  const handleSearch = (e) => {
    if (e.keyCode === 13) {
      const val = e?.target?.value;
      setSearchQuery(val);
      setSearchQueryType(searchType);
    }
  };

  return (
    <Box  {...props}>
      {searchBoxDisc?.isOpen || searchQuery?.length ? (
        <InputGroup h={"40px"} maxW={["210px","295px"]} alignItems="center">
          <InputLeftElement borderRight="1px solid #ddd" h="20px" top="10px">
            <SearchLineIcon width="23" height="23" />
          </InputLeftElement>
          <Input
            type="text"
            borderRadius="full"
            // pl="60px"
            {...(side === 'rtl' ? { pr: '60px' } : { pl: '60px' })}
            bg="transparent"
            border="1px solid #BDBDBD"
            defaultValue={searchQuery}
            height={['35px','48px']}
            onKeyDown={handleSearch}
          />
          <InputRightElement height={"40px"}   width={"40px"}>
            <CloseButton
           

              variant="transparent"
              _hover={{ bg: 'transparent' }}
              onClick={() => {
                setSearchQuery();
                searchBoxDisc?.onClose();
              }}
            />
          </InputRightElement>
        </InputGroup>
      ) : (
        <Box
          alignItems="center"
          justifyContent="center"
          display="flex"
          width="33px"
          height="33px"
          backgroundColor="#E4E6EB"
          borderRadius="100%"
          onClick={() => searchBoxDisc?.onOpen()}
        >
          <Search2Icon width={'18.02px'} height={'18px'} color={'#868585'} />
        </Box>
        // <IconButton
        //   bg={["none","#D9D9D9"]}
        //   width="36px"
        //   height="36px"
        //   borderRadius="full"
        //   icon={<Search width="23" height="23" color="#5B5B5B" />}
        //   onClick={() => searchBoxDisc?.onOpen()}
        // />
      )}
    </Box>
  );
};

export default MyNetworkSearchInput;
